import { render, staticRenderFns } from "./BranchTables.vue?vue&type=template&id=a28eec70&scoped=true&"
import script from "./BranchTables.vue?vue&type=script&lang=js&"
export * from "./BranchTables.vue?vue&type=script&lang=js&"
import style0 from "./BranchTables.vue?vue&type=style&index=0&id=a28eec70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28eec70",
  null
  
)

export default component.exports